import { useState, useEffect } from 'react';
import axios from 'axios';
import SummaryApi from '../common';
import { authHeader } from '../helpers/auth-header';

const useChatUnreadCount = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchUnreadCount = async () => {
    try {
      const response = await axios.get(SummaryApi.chatUnreadCount.url, {
        headers: authHeader(),
      });
      if (response.data?.data) {
        setUnreadCount(response.data.data.unreadCount || 0);
      }
    } catch (error) {
      // Silently fail - don't show errors for unread count
      console.error('Error fetching chat unread count:', error);
      setUnreadCount(0);
    }
  };

  useEffect(() => {
    // Initial fetch
    fetchUnreadCount();

    // Poll every 5 minutes for unread count (reduced server load)
    const interval = setInterval(() => {
      fetchUnreadCount();
    }, 300000); // 5 minutes = 300000 ms

    return () => clearInterval(interval);
  }, []);

  return { unreadCount, refreshUnreadCount: fetchUnreadCount };
};

export default useChatUnreadCount;
